import Spinner from "./Spinner.vue";
import { pluginify } from "./../../util";
export default pluginify(Spinner);
export { Spinner };
